module.exports = __webpack_public_path__ + "img/Dahlberg-25.02eadb4f.jpg";